import React from "react";
import PropTypes from "prop-types";
import LabelledRadioOption from "common/LabelledRadioOption";
import HourlyDropdown from 'common/HourlyDropdown';
import css from './RadioOptionForHourlyDropdown.scss'

// Renders a radio button with a label and an hourly dropdown option.
// The radio button selection/deselection enables/disables the dropdown.
const RadioOptionForHourlyDropdown = ({ariaLabel, labelId, radioLabel, radioGroupName, isChecked, dropdownValue, onChange, onRadioSelect}) => {
    return (
        <div className={css['hourly-option']}>
            <LabelledRadioOption isChecked={isChecked}
                                 labelId={labelId}
                                 label={radioLabel}
                                 onRadioSelect={onRadioSelect}
                                 radioGroupName={radioGroupName} />
            <div className={css['hourly-dropdown-container']}>
                <HourlyDropdown id={`${labelId}Dropdown`}
                                className={css['hourly-dropdown']}
                                ariaLabel={ariaLabel}
                                isDisabled={!isChecked}
                                onChange={onChange}
                                value={dropdownValue} />
            </div>
        </div>
    )
};

RadioOptionForHourlyDropdown.propTypes = {
    ariaLabel: PropTypes.string,
    labelId: PropTypes.string,
    radioGroupName: PropTypes.string,
    isChecked: PropTypes.bool,
    radioLabel: PropTypes.element,
    onRadioSelect: PropTypes.func,
    onChange: PropTypes.func,
    dropdownValue: PropTypes.string
};

export default RadioOptionForHourlyDropdown;
